import React from 'react'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'

import './styles.scss'
import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'

const SmartChatActivationModal = ({ isOpen, toggle, message, isCredentialConfig }) => {
  const configCredentialURL = '/dashboard/configurations/credentials'
  const history = useHistory()
  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle={toggle}
      header={' '}
      body={
        <div className='modal-content--smart-chat'>
          <div>
            <p>{I18n.t(message)}</p>
          </div>
        </div>
      }
      footer={
        <div className='buttons-container'>
          {
            isCredentialConfig
              ? <Button secondary onClick={() => history.push(configCredentialURL)}>{I18n.t('dashboard_setup-ecommerce')}</Button>
              : <Button secondary onClick={toggle}>{I18n.t('dashboard_accept')}</Button>
          }
          {
            isCredentialConfig && <Button
              value={I18n.t('dashboard_cancel')}
              onClick={toggle}
            />
          }
        </div>
      }
    />
  )
}

export default SmartChatActivationModal
